import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function ValueStack() {
  const contrastRows = [{
    option: 'Consulta médico privada',
    cost: '$50-150 USD',
    result: '1 visita, 1 receta'
  }, {
    option: 'Cremas farmacia mes',
    cost: '$30-80 USD',
    result: 'Síntoma temporal'
  }, {
    option: 'Suplementos naturales mes',
    cost: '$40-100 USD',
    result: 'Sin protocolo'
  }, {
    option: 'Tu Botiquín Completo',
    cost: '$6.97 USD',
    result: '40+ recetas forever',
    highlight: true
  }];
  return <Section className="bg-[#FDF8F0]" data-id="element-415">
      {/* Contrast Table */}
      <div className="max-w-2xl mx-auto" data-id="element-416">
        <h3 className="text-xl font-bold text-center text-[#2C1810] mb-6 uppercase tracking-wide" data-id="element-417">
          Contraste de Valor
        </h3>
        <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200" data-id="element-418">
          <div className="grid grid-cols-3 bg-gray-50 border-b border-gray-200 font-bold text-sm text-[#2C1810] uppercase tracking-wider" data-id="element-419">
            <div className="p-4" data-id="element-420">Opción</div>
            <div className="p-4" data-id="element-421">Costo</div>
            <div className="p-4" data-id="element-422">Resultado</div>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-423">
            {contrastRows.map((row, i) => <div key={i} className={`grid grid-cols-3 text-sm ${row.highlight ? 'bg-[#2D5016]/10 font-bold' : ''}`} data-id="element-424">
                <div className={`p-4 ${row.highlight ? 'text-[#2D5016]' : 'text-gray-600'}`} data-id="element-425">
                  {row.option}
                </div>
                <div className={`p-4 ${row.highlight ? 'text-[#2D5016]' : 'text-gray-600'}`} data-id="element-426">
                  {row.cost}
                </div>
                <div className={`p-4 ${row.highlight ? 'text-[#2D5016]' : 'text-gray-600'}`} data-id="element-427">
                  {row.result}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}